export type TableType = 'seeds' | 'briefs' | 'drafts';

interface TableSelectorProps {
  activeTable: TableType;
  onSelect: (table: TableType) => void;
  counts: { seeds: number; briefs: number; drafts: number };
}

const TABS: { key: TableType; label: string; desc: string; iconClass: string; letter: string }[] = [
  { key: 'seeds', label: 'Content Seeds', desc: 'Raw source content', iconClass: 'seeds', letter: 'S' },
  { key: 'briefs', label: 'Content Briefs', desc: 'Strategic plans', iconClass: 'briefs', letter: 'B' },
  { key: 'drafts', label: 'Content Drafts', desc: 'Written content', iconClass: 'drafts', letter: 'D' },
];

export function TableSelector({ activeTable, onSelect, counts }: TableSelectorProps) {
  return (
    <div class="table-tabs">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          class={`table-tab${activeTable === tab.key ? ' active' : ''}`}
          onClick={() => onSelect(tab.key)}
        >
          <div class={`table-tab-icon ${tab.iconClass}`}>{tab.letter}</div>
          <div class="table-tab-info">
            <div class="table-tab-name">{tab.label}</div>
            <div class="table-tab-count">{tab.desc}</div>
          </div>
          <span class="table-tab-badge">{counts[tab.key].toLocaleString()}</span>
        </button>
      ))}
    </div>
  );
}
